import React, { useState } from 'react';
import QRCode from 'qrcode.react';
import Card from '../common/Card';
import Button from '../common/Button';

const QRCodeTest = () => {
  const [attendeeId, setAttendeeId] = useState('1');
  const [eventId, setEventId] = useState('1');
  const [qrUrl, setQrUrl] = useState('');

  const generateQRUrl = () => {
    const baseUrl = window.location.origin;
    const url = `${baseUrl}/attendee/${attendeeId}${eventId ? `?event=${eventId}` : ''}`;
    setQrUrl(url);
    return url;
  };

  const testUrl = qrUrl || generateQRUrl();

  return (
    <div className="max-w-2xl mx-auto p-6 space-y-6">
      <Card>
        <Card.Content>
          <h2 className="text-2xl font-bold mb-4">QR Code Test</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Controls */}
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Attendee ID
                </label>
                <input
                  type="text"
                  value={attendeeId}
                  onChange={(e) => setAttendeeId(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
                  placeholder="Enter attendee ID"
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Event ID (optional)
                </label>
                <input
                  type="text"
                  value={eventId}
                  onChange={(e) => setEventId(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
                  placeholder="Enter event ID"
                />
              </div>
              
              <Button onClick={generateQRUrl} className="w-full">
                Generate QR Code
              </Button>
              
              <div className="text-sm">
                <p className="font-medium text-gray-700 mb-2">Generated URL:</p>
                <div className="bg-gray-100 p-3 rounded-lg break-all text-xs">
                  {testUrl}
                </div>
              </div>
              
              <Button
                variant="secondary"
                onClick={() => window.open(testUrl, '_blank')}
                className="w-full"
              >
                Test URL in New Tab
              </Button>
            </div>
            
            {/* QR Code Display */}
            <div className="flex flex-col items-center space-y-4">
              <div className="bg-white p-4 rounded-lg shadow-lg">
                <QRCode
                  value={testUrl}
                  size={200}
                  level="M"
                  includeMargin={true}
                />
              </div>
              <p className="text-sm text-gray-600 text-center">
                Scan this QR code with your phone to test
              </p>
            </div>
          </div>
        </Card.Content>
      </Card>
      
      <Card>
        <Card.Content>
          <h3 className="text-lg font-semibold mb-3">Testing Instructions</h3>
          <ol className="list-decimal list-inside space-y-2 text-sm text-gray-700">
            <li>Enter a valid attendee ID (check your database for existing IDs)</li>
            <li>Optionally enter an event ID for event-specific context</li>
            <li>Click "Generate QR Code" to create the URL</li>
            <li>Use the "Test URL in New Tab" button to verify the URL works</li>
            <li>Scan the QR code with your phone to test mobile access</li>
            <li>The attendee detail page should load without requiring login</li>
          </ol>
        </Card.Content>
      </Card>
    </div>
  );
};

export default QRCodeTest;
